module.exports = __webpack_public_path__ + "static/media/34.8595d58b.jpg";